import { useSelector } from 'react-redux';
import { currentCompanySettingsIsInternationalPaymentsEnabledSelector } from 'selectors/currentCompanySelectors';
export const useShouldDisableInternationalFundingAccount = (currencyCode, currencyCodeReceiver) => {
    const isInternationalPaymentsEnabled = useSelector(currentCompanySettingsIsInternationalPaymentsEnabledSelector);
    if (!isInternationalPaymentsEnabled || !currencyCodeReceiver || !currencyCode) {
        return false;
    }
    return currencyCodeReceiver !== currencyCode;
};
